import { c as _c } from "react/compiler-runtime";
import * as VisuallyHiddenPrimitive from "@radix-ui/react-visually-hidden";
import { jsx as _jsx } from "react/jsx-runtime";
export function VisuallyHidden(t0) {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = /*#__PURE__*/_jsx(VisuallyHiddenPrimitive.Root, {
      ...props,
      children: children
    });
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}